#@import _
#@import moment
#@import Booking.Presenters.Base
#@export Booking.Presenters.Calendar

class Booking.Presenters.Calendar extends Booking.Presenters.Base


  getDayLabel = (day, isBookerDeal, diff) ->
    if diff? and diff < 0
      'unavailable'
    else
      if day.events.length or isBookerDeal
        'available'
      else
        'unavailable'

  getDayBHC = (idx, days, diff) ->
    if diff?
      if diff is 0
        value = 'today'
      else
        at = if diff > 0 then 'ahead' else 'behind'
        value = "#{at}-#{Math.abs(diff)}-days"
    else
      value = if idx < days / 2 then 'last-month' else 'next-month'

  toHash: ->
    isBookerDeal = @model.isBookerDeal()

    calendarData = @options.calendarData

    numberOfColumns = calendarData.days.length / calendarData.numberOfRows
    numberOfRows = calendarData.numberOfRows
    rows = []

    now = moment()
    days = _.map calendarData.days, (day, idx) ->

      diff = day.date.diff(now, 'days') if moment.isMoment(day.date)

      day.label = getDayLabel(day, isBookerDeal, diff)
      value = getDayBHC(idx, calendarData.days.length, diff)
      day.bhc = "#{day.label}:#{value}"

      day

    for row in [0..(numberOfRows - 1)]
      firstDayIndex = row * numberOfColumns
      lastDayIndex = (row + 1) * numberOfColumns - 1
      rows[row] = days: days[firstDayIndex..lastDayIndex]

    momentStartOfMonth = moment("#{calendarData.month} #{calendarData.year}", 'MMM YYYY').startOf('month')
    momentEndOfMonth = moment(momentStartOfMonth).endOf('month')

    lastMonthAvailable = momentStartOfMonth > now
    nextMonthAvailable = momentEndOfMonth < now.add(@model.getMaxLeadTime(), 'seconds')

    loaded:             @collection.isLoaded()
    rows:               rows
    month:              calendarData.month
    year:               calendarData.year
    daysOfTheWeek:      calendarData.daysOfTheWeek
    lastMonthAvailable: lastMonthAvailable
    nextMonthAvailable: nextMonthAvailable

    bhcPrevious: 'navigateTo:previous-month'
    bhcNext: 'navigateTo:next-month'
